import React from 'react';
import '../../App.css';
import Hero from "../Hero";

function StraightHair() {
    return (
        <>
          <h1> What is Wavy Hair? </h1>
          <p> Wavy hair, also known as type 2 hair, can be split into three different subtypes: 
              2A, 2B, and 2C. It is the hair type that sits in between straight and curly hair. 
              Its pattern ranges from loose loops to ‘S’ shaped waves. What makes it different 
              from the other hair types is the curls' shape. Curly hair  has a more distinct 
              curl pattern formation, similar to corkscrews while coily hair can be seen either 
              in a ‘Z’ shaped angle or tight coils starting at the root of the scalp. The different 
              wavy hair types each have their own characteristics that set them apart. 
              2A hair tends to have a tousled texture. 2B hair consists of ‘S’ shaped waves in 
              the lengths, but sits relatively straight at the roots. 2C hair has even more 
              defined ‘S’ shaped curls that start from the root and continue down the lengths of the hair.
          </p>
          </>
    );
}

export default StraightHair;